// removed by extract-text-webpack-plugin
module.exports = {"icon_empty":"ee0btmRsXQz4P9mWc94V3","icon-empty":"_2VyvV35AoRrd_eBtGvdbKA","icon_empty-text":"_2A7Rwu07DvRnPZlSriINg8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RemindDropdown/remindDropdown.scss
// module id = 1195
// module chunks = 0